import { colors } from 'baseui/tokens';
import stylesColors from 'common/styles/styles.colors';
import { string2money } from 'common/utils/string';
import Text from 'components/elements/text';
import { format } from 'date-fns';
import {
  FullContainer,
  RowBetweenStyles,
  SeparatorHorizontal,
  SeparatorVertical,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import {
  HotelContainer,
  HotelContent,
  Container,
  GuestContent,
  TotalContent,
  TotalItemContent,
} from './styles';
import { HotelSaleHotelSalesItemFormType } from '../form-type';
import {
  calculateHotelSaleAddons,
  calculateHotelSaleDetail,
} from '../hooks/use-recalculate';

interface Props {
  parentIdx: number;
  data: HotelSaleHotelSalesItemFormType;
  hasReschedule: boolean;
}

export default function SummaryItem(props: Props) {
  const { t } = useTranslation();
  const { parentIdx, data, hasReschedule } = props;
  const subtotalGuests = calculateHotelSaleDetail(
    data.hotelSaleHotels,
    data.isByPax,
  );
  const subtotalAddons = calculateHotelSaleAddons(data.hotelSaleAddOns);
  const subtotal = subtotalGuests + subtotalAddons;

  return (
    <Container>
      <>
        <FullContainer $style={RowBetweenStyles}>
          <Text
            variant="LabelMedium"
            $style={{ color: stylesColors.primaryDefault }}
          >
            {t('ticketSales:schedule_extra', {
              extra: `${parentIdx + 1}${
                data.bookingCode ? `- ${data.bookingCode}` : ''
              }`,
            })}
          </Text>
          <Text
            variant="LabelMedium"
            $style={{ color: stylesColors.primaryDefault }}
          >
            {data.hotelName}
          </Text>
        </FullContainer>

        <GuestContent>
          <Text variant="LabelSmall">
            {data.hotelSaleGuests.map((guest) => guest.guestName).join(', ')}
          </Text>
        </GuestContent>
        {data.hotelSaleHotels.map((hotelSaleHotel, idx) => {
          const nights = hotelSaleHotel.night || 0;
          const rooms = hotelSaleHotel.room || 0;
          const nightText = `${nights} ${t(
            `common:${nights > 1 ? 'nights' : 'night'}`,
          ).toUpperCase()}`;
          const roomText = `${rooms} ${t(
            `common:${rooms > 1 ? 'rooms' : 'room'}`,
          ).toUpperCase()}`;
          const subtotal = calculateHotelSaleDetail(
            [hotelSaleHotel],
            data.isByPax,
          );
          return (
            <HotelContainer
              key={hotelSaleHotel.id || `${parentIdx}-hotelSaleHotel-${idx}`}
            >
              <HotelContent>
                <Text variant="LabelSmall">{`${
                  hotelSaleHotel.checkIn
                    ? format(hotelSaleHotel.checkIn, 'dd-MM-yyyy')
                    : '-'
                } - ${
                  hotelSaleHotel.checkOut
                    ? format(hotelSaleHotel.checkOut, 'dd-MM-yyyy')
                    : '-'
                } (${nightText}) | ${roomText} | ${
                  hotelSaleHotel.detail || '-'
                } | ${(
                  hotelSaleHotel.hotelRoomName || '-'
                ).toUpperCase()}`}</Text>
                {!hasReschedule && (
                  <>
                    <SeparatorHorizontal $margin={8} />
                    <Text
                      variant="LabelSmall"
                      $style={{ color: colors.gray500 }}
                    >
                      {`@ Rp ${string2money(hotelSaleHotel.price || 0)}`}
                    </Text>
                  </>
                )}
              </HotelContent>
              <Text variant="LabelSmall">{`Rp ${string2money(subtotal)}`}</Text>
            </HotelContainer>
          );
        })}
        {data.isCityTax && (
          <HotelContainer style={{ marginTop: 8 }}>
            <HotelContent style={{ marginRight: 8 }}>
              <Text variant="LabelSmall">{t('common:city_tax')}</Text>
            </HotelContent>
            <Text variant="LabelSmall">{data.cityTax || 0}</Text>
          </HotelContainer>
        )}
        {!!data.hotelSaleAddOns.length && (
          <Container>
            <SeparatorVertical $margin={8} />
            <Text variant="ParagraphSmall" $style={{ color: colors.gray500 }}>
              {t('ticketSales:add_ons')}
            </Text>
            {data.hotelSaleAddOns.map((addon, idx) => (
              <HotelContainer
                key={addon.id || `${parentIdx}-hotelSaleAddOns-${idx}`}
              >
                <GuestContent>
                  <Text variant="LabelSmall">
                    {`${addon.guestName || '-'} | ${addon.description || '-'}`}
                  </Text>
                  <SeparatorHorizontal $margin={8} />
                  <Text variant="LabelSmall" $style={{ color: colors.gray500 }}>
                    {`@ Rp ${string2money(addon.price || 0)}`}
                  </Text>
                </GuestContent>
                <Text variant="LabelSmall">
                  {`Rp ${string2money(addon.price || 0)}`}
                </Text>
              </HotelContainer>
            ))}
          </Container>
        )}
        <SeparatorVertical $margin={24}>
          <div style={{ height: 1, backgroundColor: colors.gray200 }} />
        </SeparatorVertical>
        {/* <TotalContent>
          <TotalItemContent>
            <Text variant="LabelMedium">{t('common:subtotal')}:</Text>
            <SeparatorHorizontal $margin={8} />
            <Text variant="HeadingXSmall">{`Rp ${string2money(
              subtotal,
            )}`}</Text>
          </TotalItemContent>
        </TotalContent> */}
      </>
    </Container>
  );
}
